export default __webpack_public_path__ + "static/media/beneficios1.7e20292f.png";